
import GroupTitle from 'vux/src/components/group-title/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'


const week = ['周日','周一','周二','周三','周四','周五','周六'];
const orderSrc = ['','公众号','自助二维码'];

export default {
components: {
Group,
GroupTitle,
Cell
},
created() {
console.log('created...')
this.initOrderInfo()
this.initShopInfo()
},
methods:{
initOrderInfo(){
let shopId = this.shopId
let _this = this;
let orderNo = this.$router.currentRoute.params.id;
let userId = this.$router.currentRoute.params.userId;
console.log(_this.$router.currentRoute.params.id)


_this.axios.post('/v1/shop/'+shopId+'/order/tuan/USER_ORDER_DETAIL', {'orderNo':orderNo,'userId':userId}, {
headers: {}
}).then(function (response) {
if (response.data.code == 0) {
_this.orderDetail = formateOrder(response.data.data)
}

}).catch(function (response) {
console.log(response);
});
},
initShopInfo(){
let shopId = this.shopId
let _this = this;
let uri = '/v1/shop/'+ shopId;
let params = null;
_this.axios.get(uri, params, {
headers: {}
}).then(function (response) {
if (response.data.code == 0) {

_this.shopName = response.data.data.name
} else {

console.log('处理错误提醒');
}
}).catch(function (response) {
console.log(response);

});
}
},
data () {
return {
shopName: '',
orderDetail: {},
shopId: this.$route.params.shopId
}
}
}

function formateOrder(data) {
let validDate = "";
let d1 = data.goodsInfo.validStartDate;
let d2 = data.goodsInfo.validEndDate;
let date1 = new Date(d1);
let date2 = new Date(d2);
if (date1-date2==0) {
validDate = d1 + "(" + week[date1.getDay()] + ")";
} else {
validDate = d1 + "(" + week[date1.getDay()] + ")  至  " + d2 + "(" + week[date2.getDay()] + ")";
}
let rs = {
orderNo: data.orderNo,
goodsName: data.goodsInfo.goodsName,
specificationName: data.goodsInfo.specificationName,
goodsNum: data.goodsInfo.quantity,
validDate: validDate,
price: "￥"+data.totalPrice/data.goodsInfo.quantity*0.01,
totalPrice: "￥"+data.totalPrice*0.01,
realPrice: data.realPrice != null ? "￥"+data.realPrice*0.01 : null,
contact: data.guestNames,
sourceName: orderSrc[data.saleChannelType],
createTime: data.createAt,
statusName: data.showStatus,
mobile: data.mobileNo
}
return rs
}



// WEBPACK FOOTER //
// ./src/components/tuan_order/Detail.vue